'use strict';

import Swiper from 'swiper';
import AOS from 'aos';

window.Swiper = Swiper;
window.AOS = AOS;

$(function () {
  AOS.init({
  })  
});

//매거진 커버
document.addEventListener("DOMContentLoaded", function() {
  const isTablet = window.innerWidth >= 768 && window.innerWidth < 1200;

  const thumbItem = document.querySelector(".cover-thumb");
  if (thumbItem !== null) {      
    const thumbH = thumbItem.offsetHeight;
    const coverH = document.querySelector(".cover-head").offsetHeight;
    const coverCont = document.querySelector(".cover-contents");    
    coverCont.style.marginTop = `-${coverH}px`;
    
    let rafId = null;
    window.addEventListener("scroll",()=>{
      const scrollTop = document.scrollingElement.scrollTop;
      let marginTop = coverH+(scrollTop*0.7);
      if(marginTop < thumbH-coverH){  
        coverCont.style.marginTop = `-${marginTop}px`;
        if (isTablet) {
          if (rafId) cancelAnimationFrame(rafId);
          rafId = requestAnimationFrame(() => {
            AOS.refresh();
          });
        }
      }
    })
  }
});

$("[data-button-type='modal']").on("click", function() {
  var target = $(this).attr("data-target");
  if (target) {
    // 1. 열려 있는 모든 모달 닫기
    $(".melon-modal").hide().attr('tabindex', '');
    $("html").removeClass("dimmed");
    $(".melon-container").attr('aria-hidden', false);

    // 2. 클릭한 버튼의 대상 모달 열기
    showModal(target);
  }
});


// 글자 크기 조정
document.addEventListener('DOMContentLoaded', function() {
  const fontButtons = document.querySelectorAll('.list-bottomsheet .btn-font');
  const contentMelons = document.querySelectorAll('.content-melon');
  const classMap = ['', 'content-melon-x2', 'content-melon-x3'];
  fontButtons.forEach((btn, index) => {
    btn.addEventListener('click', function() {
      fontButtons.forEach(b => b.classList.remove('on'));
      this.classList.add('on');
      const addClass = classMap[index] || '';
      contentMelons.forEach(el => {
        el.className = addClass ? `content-melon ${addClass}` : 'content-melon';
      });
    });
  });
});



function closeLayer() {
  const layer = document.querySelector(".modal-half");
  const contContainer = document.querySelector(".melon-container");
  const htmlEl = document.documentElement;

  layer.style.display = "none";
  contContainer.setAttribute('aria-hidden', 'false');
  htmlEl.classList.remove('dimmed');
}

document.addEventListener('DOMContentLoaded', function() {
  // 닫기 버튼
  const btnClose = document.querySelector(".control-half .btn-control");
  if (btnClose) {
    btnClose.addEventListener('click', closeLayer);
  }

  // 스와이프 다운으로 닫기
  const modalLayer = document.querySelector(".modal-half .modal-layer");
  if (modalLayer) {
    var startY = 0;
    var isDragging = false;

    modalLayer.addEventListener('touchstart', function(e) {
      startY = e.touches[0].clientY;
      isDragging = true;
    }, { passive: true });

    modalLayer.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      var moveY = e.touches[0].clientY - startY;

      // 아래로 드래그할 때만 모달 따라 내려오게
      if (moveY > 0) {
        modalLayer.style.transform = 'translateY(' + moveY + 'px)';
        modalLayer.style.transition = 'none';
      }
    }, { passive: true });

    modalLayer.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      isDragging = false;

      var endY = e.changedTouches[0].clientY;
      var distance = endY - startY;

      if (distance > 100) {
        // 100px 이상 내리면 닫기
        modalLayer.style.transform = '';
        modalLayer.style.transition = '';
        closeLayer();
      } else {
        // 100px 미만이면 원위치
        modalLayer.style.transition = 'transform 0.3s ease';
        modalLayer.style.transform = '';
      }
    });
  }
});


//empty 높이설정
$(function() {
  var emptyArea = function(paramOpt) {
    var nolist = $('.nolist-data');
    if (nolist.length == 0) return;
  
    var dh = window.innerHeight ? window.innerHeight : $(window).height();
    var h = {
      headerH : $('.melon-header').outerHeight(),
      coverH : $('.cover-contents').outerHeight()
    }
    var total = 0;
    for (var i in h) {
      if (h[i] == null) h[i] = 0;
      total += h[i];
    }
    
    total = dh - total;
    if (total < 113) total = 113;
    $('.nolist-data').height(total);
  }
  emptyArea();

  var gw = $(window).width();
  $(window).resize(function() {
    var w = $(window).width();
    if (gw == w) return;
    emptyArea();
  });
});

//photoviewer 높이 설정
// $(function() {
//   var photoViewrHeight = function(paramOpt) {
//     var me = $('.wrap-photoviewer');
//     if (me.length == 0) return;
  
//     var dh = window.innerHeight ? window.innerHeight : $(window).height();
//     var h = {
//       headerH : $('.melon-header').outerHeight() 
//     }
//     var total = 0;
//     for (var i in h) {
//       if (h[i] == null) h[i] = 0;
//       total += h[i];
//     }
    
//     total = dh - total + 56;
//     $('.wrap-photoviewer').height(total);
//   }
//   photoViewrHeight();

//   var gw = $(window).width();
//   $(window).resize(function() {
//     var w = $(window).width();
//     if (gw == w) return;
//     photoViewrHeight();
//   });
// });
